import React from 'react';
import Fleck from './Fleck';
import styles from './Flecks.module.scss';
import { motion } from 'framer-motion';
import { RGBData } from '../../../types/colours';

export interface FlecksProps {
	dominantColor: RGBData;
	colorPalette: RGBData[];
}

const Flecks: React.FC<FlecksProps> = ({ dominantColor, colorPalette = [] }) => (
	<motion.div
		initial={{ opacity: 0 }}
		animate={{ opacity: 0.8 }}
		exit={{ opacity: 0, transition: { duration: 2 } }}
		style={{ backgroundColor: `rgb(${dominantColor.r}, ${dominantColor.g}, ${dominantColor.b})` }}
		className={styles.flecks}
	>
		{colorPalette.map((color, index) => (
			<Fleck index={index} key={index} color={color} />
		))}
	</motion.div>
);

export default Flecks;
